import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LegalEntityQueryKey } from './queryKey';
export var useDeleteLegalEntity = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (id) { return api.base.delete("/api/legalentity/".concat(id)).then(function () { return id; }); }, {
        onSuccess: function (deletedId) {
            queryClient.setQueryData([LegalEntityQueryKey.LegalEntities], function (old) {
                return old ? old.filter(function (e) { return e.id !== deletedId; }) : old;
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { deleteLegalEntity: mutateAsync, isLoading: isLoading };
};
